import { render } from "./IGenerateImage.vue?vue&type=template&id=42489bc2"
import script from "./IGenerateImage.vue?vue&type=script&lang=js"
export * from "./IGenerateImage.vue?vue&type=script&lang=js"

import "./IGenerateImage.vue?vue&type=style&index=0&id=42489bc2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__